import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import AuthCallback from "@/components/auth/AuthCallback";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import LoginPage from "@/components/auth/LoginPage";
import PendingApprovalPage from "@/components/auth/PendingApprovalPage";
import LandingPage from "@/components/landing/LandingPage";
import InvestorPortal from "@/components/portal/InvestorPortal";
import DealDetail from "@/components/portal/DealDetail";
import Watchlist from "@/components/portal/Watchlist";
import ProfilePage from "@/components/portal/ProfilePage";
import BlogPage from "@/components/blog/BlogPage";
import BlogPostPage from "@/components/blog/BlogPostPage";
import NewsroomPage from "@/components/media/NewsroomPage";
import LeadershipPage from "@/components/leadership/LeadershipPage";
import FAQPage from "@/components/faq/FAQPage";
import LegalPage from "@/components/legal/LegalPage";
import AdminPanel from "@/components/admin/AdminPanel";
import usePageTracker from "@/hooks/usePageTracker";

function AppRouter() {
  const location = useLocation();
  usePageTracker();

  // CRITICAL: Detect session_id during render (NOT in useEffect)
  // useEffect runs AFTER first render - too late!
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pending" element={
        <ProtectedRoute allowPending={true}><PendingApprovalPage /></ProtectedRoute>
      } />
      <Route path="/portal" element={
        <ProtectedRoute><InvestorPortal /></ProtectedRoute>
      } />
      <Route path="/portal/deal/:dealId" element={
        <ProtectedRoute><DealDetail /></ProtectedRoute>
      } />
      <Route path="/portal/watchlist" element={
        <ProtectedRoute><Watchlist /></ProtectedRoute>
      } />
      <Route path="/portal/profile" element={
        <ProtectedRoute><ProfilePage /></ProtectedRoute>
      } />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/newsroom" element={<NewsroomPage />} />
      <Route path="/leadership" element={<LeadershipPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/terms" element={<LegalPage slug="terms" />} />
      <Route path="/privacy" element={<LegalPage slug="privacy" />} />
      <Route path="/admin" element={
        <ProtectedRoute requiredRole="admin"><AdminPanel /></ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
